module.exports = __webpack_public_path__ + "static/media/zhike-logo.dda7a22f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Material/zhike-logo.svg
 ** module id = 306
 ** module chunks = 0
 **/